import React from 'react'
import Icon from './Icon'

const Add = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g fill="none">
        <path d="M0 40h40V0H0z"/>
        <path fill="currentColor" d="M26.5 12c.827 0 1.5.673 1.5 1.5v11c0 .827-.673 1.5-1.5 1.5h-11c-.827 0-1.5-.673-1.5-1.5v-11c0-.827.673-1.5 1.5-1.5h11zm.5 12.5v-11a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5zM25.5 27a.5.5 0 0 1 0 1h-12c-.827 0-1.5-.673-1.5-1.5v-12a.5.5 0 0 1 1 0v12a.5.5 0 0 0 .5.5h12zm-1-9a.5.5 0 0 1 0 1H22v2.5a.5.5 0 0 1-1 0V19h-2.5a.5.5 0 0 1 0-1H21v-2.5a.5.5 0 0 1 1 0V18h2.5z"/>
    </g>
  </Icon>
)

export default Add



// WEBPACK FOOTER //
// ./icons/Add.js